﻿import React, { useState } from 'react';

import Tab, { type TabProps } from './Tab';

import styles from './styles.module.scss';

interface TabListProps {
  children: React.ReactNode;
}

const TabList: React.FC<TabListProps> = ({ children }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className={styles.tablist} role="tablist">
      {Array.isArray(children) &&
        React.Children.map(children, (child: React.ReactElement, index: number) => {
          if ((child as React.ReactElement<TabProps>).type === Tab) {
            const isActive = activeTab === index;

            return React.cloneElement(child as React.ReactElement<TabProps>, {
              id: `tab-${index}`,
              key: `tab-${index}`,
              isActive,
              handleClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                setActiveTab(index);
                const childWithProps = child as React.ReactElement<TabProps>;
                if (childWithProps.props.handleClick) {
                  childWithProps.props.handleClick(event);
                }
              },
            });
          }
          return child;
        })}
    </div>
  );
};

export default TabList;
